export const EVENT_NAME = 'SelectBB';

export class SelectionHintEvent {
	constructor(props) {
		// @ts-expect-error ts-migrate FIXME
		this.options = {
			detail: {},
			bubbles: true,
			cancelable: false,
			...props.options,
		};
		// @ts-expect-error ts-migrate FIXME
		this.listener = props.listener;
	}

	addListener() {
		// @ts-expect-error ts-migrate FIXME
		window.addEventListener(EVENT_NAME, this.listener);
	}

	removeListener() {
		// @ts-expect-error ts-migrate FIXME
		window.removeEventListener(EVENT_NAME, this.listener);
	}

	dispatch() {
		// @ts-expect-error ts-migrate FIXME
		window.dispatchEvent(new CustomEvent(EVENT_NAME, this.options));
	}
}
